import Vue from 'vue'
import Router from 'vue-router'
//import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [

    //================================== 登录
    {
      name: 'Login',
      path: '/login',
      component: () => import('../views/login/Login'),
      meta: {
        title: '登录',
        requireLogin: false
      }
    },
    {
      name: 'Reg',
      path: '/reg',
      component: () => import('../views/login/Reg'),
      meta: {
        title: '注册',
        requireLogin: false
      }
    },
    {
      name: 'Sso',
      path: '/sso',
      component: () => import('../views/login/Sso'),
      meta: {
        title: '',//SSO
      }
    },
    {
      name: 'Redirect',
      path: '/redirect/:path(.*)',
      component: () => import('../views/redirect/index'),
      meta: {
        title: '',//重定向
      }
    },
    //================================== 首页
    {
      name: 'Index',
      path: '/',
      component: () => import('../views/index/Index'),
      meta: {
        title: '首页',
        requireLogin: true,
      }
    },
    {
      name: 'Search',
      path: '/search',
      component: () => import('../views/index/Search'),
      meta: {
        title: '搜索',
        requireLogin: true,
      }
    },

    // ===================== 自学课程
    {
      name: 'Selfstudy',
      path: '/selfstudy',
      component: () => import('../views/selfstudy/Index'),
      meta: {
        title: '自学课程',
        requireLogin: true,
        keepAlive: true,
      }
    },
    // =============== 详情页
    {
      name: 'CurriculumViews',
      path: '/curriculumViews',
      component:() => import('../views/curriculumViews/Index'),
      meta: {
        title: '课程详情',
        requireLogin: true
      }
    },
    // =============== 查看课程详情
    {
      name: 'ListView',
      path: '/listview',
      component: () => import('../views/bulletinboard/ListView'),
      meta: {
        title: '课程列表',
        requireLogin: false,
      }
    },
    // =============== 查看课程详情
    {
      name: 'ViewCurriculumViews',
      path: '/viewcurriculumViews',
      component: () => import('../views/bulletinboard/ViewCurriculumViews'),
      meta: {
        title: '查看课程详情',
        requireLogin: false,
      }
    },
    // =============== 分享
    // {
    //   name: 'Share',
    //   path: '/share',
    //   component:() => import('../views/curriculumViews/Share'),
    //   meta: {
    //     title: '分享',
    //     requireLogin: true
    //   }
    // },
    {
      name: 'StudentList',
      path: '/studentlist',
      component:() => import('../views/curriculumViews/StudentList'),
      meta: {
        title: '学员列表',
        requireLogin: true
      }
    },

    // ======================   开始学习页面
    {
      name: 'Study',
      path: '/study',
      component:() => import('../views/curriculumViews/Study'),
      meta: {
        title: '开始学习',
        requireLogin: true
      }
    },
    {
      name: 'StudyView',
      path: '/studyview',
      component: () => import('../views/bulletinboard/StudyView'),
      meta: {
        title: '开始学习',
        requireLogin: false,
      }
    },
    // ======================   PC_开始学习页面
    {
      name: 'PcStudy',
      path: '/pcstudy',
      component:() => import('../views/curriculumViews/PcStudy'),
      meta: {
        title: '开始学习',
        requireLogin: true
      }
    },
    // ======================  PC_查看课程详情
    {
      name: 'PcStudyView',
      path: '/pcstudyview',
      component: () => import('../views/bulletinboard/PcStudyView'),
      meta: {
        title: '查看课程详情',
        requireLogin: false,
      }
    },

    // ===================== 培训中心
    {
      name: 'Train',
      path: '/train',
      component: () => import('../views/train/Index'),
      meta: {
        title: '培训中心',
        requireLogin: true,
        keepAlive: true,
      }
    },
    //培训详情
    {
      name: 'TrainView',
      path: '/trainview',
      component: () => import('../views/train/View'),
      meta: {
        title: '培训中心',
        requireLogin: true,
      }
    },
    {
      name: 'Courseware',
      path: '/train/courseware',
      component: () => import('../views/train/Courseware'),
      meta: {
        title: '课件预览',
        requireLogin: true,
      }
    },
    {
      name: 'PcCourseware',
      path: '/train/pccourseware',
      component: () => import('../views/train/PcCourseware'),
      meta: {
        title: '课件预览',
        requireLogin: true,
      }
    },
    {
      name: 'ScanViews',
      path: '/train/scanviews',
      component: () => import('../views/train/ScanViews'),
      meta: {
        title: '线下签到',
        requireLogin: true,
      }
    },


    // ==================  学习地图
    {
      name: 'StudyList',
      path: '/studymap/studylist',
      component: () => import('../views/studymap/StudyList'),
      meta: {
        title: '学习地图',
        requireLogin: true,
        keepAlive: true,
      }
    },
    // == 学习地图阶段页面
    {
      name: 'StudyStage',
      path: '/studymap/studystage',
      component: () => import('../views/studymap/StudyStage'),
      meta: {
        title: '学习地图',
        requireLogin: true,
      }
    },



    // ===================== 专项认证
    {
      name: 'Special',
      path: '/special',
      component: () => import('../views/special/Index'),
      meta: {
        title: '专项认证',
        requireLogin: true,
        keepAlive: true,
      }
    },
    {
      name: 'SpecialViews',
      path: '/specialviews',
      component: () => import('../views/special/SpecialViews'),
      meta: {
        title: '专项认证详情',
        requireLogin: true,
      }
    },
    {
      name: 'CertificateView',
      path: '/crtificateview',
      component: () => import('../views/special/CertificateView'),
      meta: {
        title: '证书详情',
        requireLogin: true,
      }
    },

    // ===================== 学分兑换
    {
      name: 'Credit',
      path: '/credit',
      component: () => import('../views/credit/Index'),
      meta: {
        title: '学分兑换',
        requireLogin: true,
      }
    },
    {
      name: 'CreditView',
      path: '/creditview',
      component: () => import('../views/credit/CreditView'),
      meta: {
        title: '商品详情',
        requireLogin: true,
      }
    },

    // ===================== 干货社区
    {
      name: 'Driedfood',
      path: '/driedfood',
      component: () => import('../views/driedfood/Index'),
      meta: {
        title: '干货社区',
        requireLogin: true,
      }
    },
    {
      name: 'DriedFoodView',
      path: '/driedfoodview',
      component: () => import('../views/driedfood/DriedFood'),
      meta: {
        title: '干货详情',
        requireLogin: true,
      }
    },

    // ===================== 大咖讲师
    {
      name: 'Lecturer',
      path: '/lecturer',
      component: () => import('../views/lecturer/Index'),
      meta: {
        title: '大咖讲师',
        requireLogin: true,
      }
    },
    {
      name: 'Teacher',
      path: '/teacher',
      component: () => import('../views/lecturer/Teacher'),
      meta: {
        title: '讲师详情',
        requireLogin: true,
      }
    },

    // ========================== 考试
    {
      name: 'Exam',
      path: '/exam',
      component: () => import('../views/exam/Index'),
      meta: {
        title: '在线考试',
        requireLogin: true,
      }
    },
    {
      name: 'ExamViews',
      path: '/examviews',
      component: () => import('../views/exam/ExamViews'),
      meta: {
        title: '试卷详情',
        requireLogin: false,
      }
    },


    // ========================== 考试详情
    {
      name: 'ViewExam',
      path: '/viewexam',
      component: () => import('../views/bulletinboard/ViewExam'),
      meta: {
        title: '考试详情',
        requireLogin: true,
      }
    },
    // ====================  个人中心
    {
      name: 'Me',
      path: '/Me',
      component: () => import('../views/me/Me'),
      meta: {
        title: '个人中心',
        requireLogin: true,
      }
    },
    {
      name: 'Myprofile',
      path: '/myprofile',
      component: () => import('../views/me/Myprofile'),
      meta: {
        title: '修改个人资料',
        requireLogin: true,
      }
    },

    // ================ 我的学分
    {
      name: 'MyPoint',
      path: '/mypoint',
      component: () => import('../views/me/MyPoint'),
      meta: {
        title: '我的学分',
        requireLogin: true,
      }
    },
    // ================ 我的勋章
    {
      name: 'MyMedal',
      path: '/mymedal',
      component: () => import('../views/me/MyMedal'),
      meta: {
        title: '我的勋章',
        requireLogin: true,
      }
    },
    // ================ 我的卡券
    {
      name: 'CardDetail',
      path: '/carddetail',
      component: () => import('../views/card/CardDetail'),
      meta: {
        title: '卡券详情',
        requireLogin: true,
      }
    },
    // ================ 我的卡券详情
    {
      name: 'MyCard',
      path: '/mycard',
      component: () => import('../views/me/mycard'),
      meta: {
        title: '我的卡券',
        requireLogin: true,
      }
    },
    // ================ 我的学分
    {
      name: 'Mycertificate',
      path: '/mycertificate',
      component: () => import('../views/me/Mycertificate'),
      meta: {
        title: '我的证书',
        requireLogin: true,
      }
    },

    // ================ 我的课程
    {
      name: 'MySelfstudy',
      path: '/myselfstudy',
      component: () => import('../views/me/MySelfstudy'),
      meta: {
        title: '我的课程',
        requireLogin: true,
      }
    },
    // ================ 我的培训
    {
      name: 'MyTrain',
      path: '/mytrain',
      component: () => import('../views/me/MyTrain'),
      meta: {
        title: '我的培训',
        requireLogin: true,
        keepAlive: true,
      }
    },
    // ================ 我的直播
    {
      name: 'MyLive',
      path: '/mylive',
      component: () => import('../views/me/MyLive'),
      meta: {
        title: '我的直播',
        requireLogin: true,
      }
    },
    // ================ 我的专项认证
    {
      name: 'MySpecial',
      path: '/myspecial',
      component: () => import('../views/me/MySpecial'),
      meta: {
        title: '我的专项认证',
        requireLogin: true,
      }
    },
    // ================ 我的学习地图
    {
      name: 'MyLearningMap',
      path: '/Mylearningmap',
      component: () => import('../views/me/MyLearningMap'),
      meta: {
        title: '我的学习地图',
        requireLogin: true,
      }
    },
    {
      name: 'StudyMap',
      path: '/studymap',
      component: () => import('../views/studymap/Index'),
      meta: {
        title: '学习地图',
        requireLogin: true,
      }
    },
    // ================ 我的学习地图
    {
      name: 'Myexamination',
      path: '/myexamination',
      component: () => import('../views/me/Myexamination'),
      meta: {
        title: '我的考试',
        requireLogin: true,
      }
    },
    // ================ 我的问答
    {
      name: 'MyProblem',
      path: '/mypyproblem',
      component: () => import('../views/me/MyProblem'),
      meta: {
        title: '我的问答',
        requireLogin: true,
      }
    },
    // ================ 教师身份 我的回复
    {
      name: 'MyReply',
      path: '/myreply',
      component: () => import('../views/me/MyReply'),
      meta: {
        title: '我的回复',
        requireLogin: true,
      }
    },
    // ================ 我的收藏
    {
      name: 'MyFav',
      path: '/myfav',
      component: () => import('../views/me/MyFav'),
      meta: {
        title: '我的收藏',
        requireLogin: true,
      }
    },
    // ================ 我的干货
    {
      name: 'MyArticle',
      path: '/myarticle',
      component: () => import('../views/me/MyArticle'),
      meta: {
        title: '我的干货',
        requireLogin: true,
      }
    },
    // =============== 创建干货
    {
      name: 'CreateArticle',
      path: '/createarticle',
      component: () => import('../views/me/CreateArticle'),
      meta: {
        title: '发布干货',
        requireLogin: true,
      }
    },
    // ================ 干货详情
    {
      name: 'ArticleView',
      path: '/articleview',
      component: () => import('../views/me/ArticleView'),
      meta: {
        title: '干货详情',
        requireLogin: true,
      }
    },

    // ================ 我的学员
    {
      name: 'MyStudent',
      path: '/mystudent',
      component: () => import('../views/me/MyStudent'),
      meta: {
        title: '我的学员',
        requireLogin: true,
        keepAlive: true,
      }
    },

    // ================ 到期证书
    {
      name: 'OverCertificate',
      path: '/overcertificate',
      component: () => import('../views/me/OverCertificate'),
      meta: {
        title: '到期证书',
        requireLogin: true,
        keepAlive: true,
      }
    },
    // ================ 我的学员统计
    {
      name: 'MyStatistics',
      path: '/mystatistics',
      component: () => import('../views/me/MyStatistics'),
      meta: {
        title: '学员统计',
        requireLogin: true,
      }
    },
    // 创建线下培训
    {
      name: 'CreateOfflineTrain',
      path: '/createofflinetrain',
      component: () => import('../views/createOfflinetrain/Index'),
      meta: {
        title: '创建线下培训',
        requireLogin: true,
      }
    },
    {
      name: 'CreateTrain',
      path: '/createtrain',
      component: () => import('../views/createOfflinetrain/CreateTrain'),
      meta: {
        title: '创建线下培训',
        requireLogin: true,
      }
    },

    // ===================订单管理
    {
      name: 'Order',
      path: '/order',
      component: () => import('../views/order/Index'),
      meta: {
        title: '我的订单',
        requireLogin: true,
      }
    },
    {
      name: 'OrderView',
      path: '/orderview',
      component: () => import('../views/order/Order'),
      meta: {
        title: '订单详情',
        requireLogin: true,
      }
    },

    {
      name: 'SignStudentList',
      path: '/signStudentList',
      component: () => import('../views/createofflinetrain/SignStudentList'),
      meta: {
        title: '培训学员',
        requireLogin: true,
      }
    },
    {
      name: 'VerifiyInfo',
      path: '/verifiyInfo',
      component: () => import('../views/card/VerifiyInfo'),
      meta: {
        title: '核销',
        requireLogin: true,
      }
    },
    {
      name: 'SignForm',
      path: '/signForm',
      component: () => import('../views/train/SignForm'),
      meta: {
        title: '填写报名信息',
        requireLogin: true,
      }
    },
    {
      name: 'SignFormList',
      path: '/signFormList',
      component: () => import('../views/train/SignFormList'),
      meta: {
        title: '报名信息',
        requireLogin: true,
      }
    },
    {
      name: 'TrainOrderDetail',
      path: '/trainOrderDetail',
      component: () => import('../views/order/TrainOrderDetail'),
      meta: {
        title: '培训订单详情',
        requireLogin: true,
      }
    },
    {
      name: 'CommonSign',
      path: '/commonSign',
      component: () => import('../views/train/commonSign'),
      meta: {
        title: '培训报名',
        requireLogin: true,
      }
    },
    {
      name: 'RefundList',
      path: '/refundList',
      component: () => import('../views/order/refundList'),
      meta: {
        title: '培训订单退款列表',
        requireLogin: true,
      }
    },
    {
      name: 'RefundDetail',
      path: '/refundDetail',
      component: () => import('../views/order/refundDetail'),
      meta: {
        title: '培训退款订单详情',
        requireLogin: true,
      }
    },
    // 购物车
    {
      name: 'Cart',
      path: '/cart',
      component: () => import('../views/cart/Index'),
      meta: {
        title: '购物车',
        requireLogin: true,
      }
    },
    {
      name: 'CartAdress',
      path: '/cartadress',
      component: () => import('../views/cart/CartAdress'),
      meta: {
        title: '订单信息',
        requireLogin: true,
      }
    },
    // 大转盘
    {
      name: 'Turntable',
      path: '/turntable',
      component: () => import('../views/Turntable/index'),
      meta: {
        title: '大转盘',
        requireLogin: true,
      }
    },




    //================================== 其他
    {
      path: '*',
      redirect: '/'
    },












  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if( to.hash ){
        return {
          selector: to.hash
        }
      } else {
        return {
          x: 0,
          y: 0
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js